<template>
  <div>
    <form-multiselect
      :value="value"
      :name="name"
      :options="timeOptions"
      @input="onInput"
      :placeholder="placeholder"
      :error="error"
      :data-vv-as="vvAs"
    ></form-multiselect>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Select a time',
    },
    error: [String, Array, Object],
    name: String,
    vvAs: String,
    value: String,
    workingDay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    timeOptions() {
      let arr = [],
        i,
        j;
        const startTime = this.workingDay ? 9 : 0;
        const endTime = this.workingDay ? 19 : 23;
      for (i = startTime; i <= endTime; i++) {
        const hour = i < 10 ? `0${i}` : i;
        for (j = 0; j < 4; j++) {
          arr.push(`${hour}:${j === 0 ? '00' : 15 * j}`);
        }
      }

      return arr;
    },
  },

  methods: {
    onInput(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style scoped>
</style>
